import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { StepTemplateBaseComponent } from 'app/core/components/dynamic-onboarding/step-template-base/step-template-base.component';
import { Observable } from 'rxjs/Observable';
import { AccountService } from 'app/agora/components/account-data/accounts/account.service';
import { ConfigService } from 'app/core/services/config.service';
import { AmberApi } from 'app/core/models/api-helpers';
import { ChildState } from 'app/core/components/dynamic-onboarding/dynamic-onboarding.component';
import { DynamicOnboardingService } from 'app/core/components/dynamic-onboarding/dynamic-onboarding.service';

declare var $;

@Component({
  selector: 'itpx-overview-card',
  templateUrl: './overview-card.component.html',
  styleUrls: ['./overview-card.component.css']
})
export class OverviewCardComponent extends StepTemplateBaseComponent {

  @ViewChild('table') table: any;
  // private imageKey: any;
  // private imageBucket: any;
  // private imgSrc: string;
  // private addressesFields: any;
  private domainDetails: any;
  // private domainName: any;
  // private employees: any;
  // @Input() private form: FormGroup;
  // @Input() private employeeTrigger: any;
  // @Input() nextClicked: Observable<void>;
  // @Output() proceed = new EventEmitter<boolean>();

  constructor(
    // private organizationService: OrganizationDetailsService,
    private accountService: AccountService,
    private service: DynamicOnboardingService,
    private configService: ConfigService
  ) {
    super();
  }

  ngOnInit() {
    this.domainDetails = this.parentForm.get('organisationDetails').value;
    this.status.emit(ChildState.enabled); //Enable next button
    this.next.bindToLifecycle(this).filter(input => input === this.id).subscribe(_ => this.status.emit(ChildState.done));

      this.stepState$.delay(50).subscribe(_ => {
          this.checkOverflow();
      })
  }

  private checkOverflow() {
    let overflow: number = this.table.nativeElement.parentElement.offsetWidth - this.table.nativeElement.parentElement.clientWidth;
    if (this.table.nativeElement.clientHeight > this.table.nativeElement.parentElement.clientHeight) {
      this.table.nativeElement.parentElement.style.marginRight = `-${overflow ? overflow + 1 : '18'}px`;
      this.table.nativeElement.parentElement.style.paddingRight = '1px';
    }else{
        this.table.nativeElement.parentElement.style.marginRight = '0';
        this.table.nativeElement.parentElement.style.paddingRight = '0';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/dynamic-onboarding/overview-card/overview-card.component.ts